import {createAsyncThunk} from '@reduxjs/toolkit';

import {slicesNames} from '../constants';
import {analyticsCustomersThunkNames} from './constants';
import {getAnalyticsCustomers, updateCustomers} from '../../../api/analyticsCustomers';
import {setPopUp} from '../popUp/popUpSlice';
import {defaultErrorMessage, popUpInfo} from '../../../globalConstants';
import {IAnalyticsData} from '../../../api/analyticsCustomers/types';

export const fetchAnalyticsCustomers = createAsyncThunk(
    `${slicesNames.analyticsCustomers}/${analyticsCustomersThunkNames.fetchAnalyticsCustomers}`,
    async (data: IAnalyticsData, {dispatch}) => {
        try {
            const response = await getAnalyticsCustomers(data);
            return response.data;
        } catch (err) {
            const {message} = err.response.data || defaultErrorMessage;
            dispatch(
                setPopUp({
                    data: {
                        severity: popUpInfo.severities.ERROR,
                        summary: popUpInfo.summary.ERROR,
                        detail: message,
                        life: 3000,
                        sticky: '',
                    },
                }),
            );
        }
    },
);

export const updateAnalyticsCustomers = createAsyncThunk(
    `${slicesNames.analyticsCustomers}/${analyticsCustomersThunkNames.updateAnalyticsCustomers}`,
    async (data: IAnalyticsData, {dispatch}) => {
        try {
            const response = await updateCustomers(data);
            return response.data;
        } catch (err) {
            const {message} = err.response.data || defaultErrorMessage;
            dispatch(
                setPopUp({
                    data: {
                        severity: popUpInfo.severities.ERROR,
                        summary: popUpInfo.summary.ERROR,
                        detail: message,
                        life: 3000,
                        sticky: '',
                    },
                }),
            );
        }
    },
);
